/**
 * Heartbeat RAG display constants (M4).
 * Mirror backend constants/deviceRag.js — labels and keys only; no threshold math on client.
 */

export const RAG_STATUS = Object.freeze({
  ACTIVE: 'active',
  STANDBY: 'standby',
  OFFLINE: 'offline',
});

export const RAG_LABEL = Object.freeze({
  ACTIVE: 'Active',
  STANDBY: 'Standby',
  OFFLINE: 'Offline',
});

export const CONNECTION_LABEL = Object.freeze({
  CONNECTED: 'Connected',
  NOT_CONNECTED: 'Not Connected',
});

/** CSS class for inline badges (AddDevice, map popup). */
export const RAG_BADGE_CLASS = Object.freeze({
  [RAG_STATUS.ACTIVE]: 'active',
  [RAG_STATUS.STANDBY]: 'standby',
  [RAG_STATUS.OFFLINE]: 'offline',
});

/** Display label per ragStatus key — single source for badge text + table class. */
export const RAG_LABEL_BY_STATUS = Object.freeze({
  [RAG_STATUS.ACTIVE]: RAG_LABEL.ACTIVE,
  [RAG_STATUS.STANDBY]: RAG_LABEL.STANDBY,
  [RAG_STATUS.OFFLINE]: RAG_LABEL.OFFLINE,
});

/** CommonTable suffix: `${label.toLowerCase()}-status` e.g. active-status */
export const TABLE_STATUS_CLASS_SUFFIX = '-status';

export const DEFAULT_RAG_STATUS = RAG_STATUS.OFFLINE;
export const DEFAULT_RAG_LABEL = RAG_LABEL.OFFLINE;
